module.exports = __webpack_public_path__ + "img/top_catch02.0b603679.jpg";